import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { PricingComponent } from '../../../v2/homeV2/pricing-v2/pricing-v2.component';
import { CP_ICONS } from '../../shared/icons';
import { BODY, BTN_PRIMARY, BTN_SECONDARY, H2, H3, LEAD, SECTION_INNER, SECTION_PAD, TEXT_LINK } from '../../shared/ui';

export type Plan = PricingComponent['plans'][number];

/** v3 copy fixes applied on top of the v2 plan data (Stripe mapping is untouched). */
export function toV3Plan(plan: Plan): Plan {
  if (plan.name !== 'Enterprise') {
    return plan;
  }
  return {
    ...plan,
    price: 'Custom pricing',
    cta: 'Contact Us',
    features: plan.features.map((f) => f.replace('acscount', 'account')),
  };
}

/**
 * Reuses v2 checkout (handlePlanAction, Stripe lookup, error/loading signals)
 * with a v3 layout: the one plan you can buy today leads, the others sit beside it.
 */
@Component({
  selector: 'app-pricing-v3',
  standalone: true,
  imports: [NgIcon],
  viewProviders: [provideIcons(CP_ICONS)],
  templateUrl: './pricing-v3.component.html',
})
export class PricingV3Component extends PricingComponent {
  readonly inner = SECTION_INNER;
  readonly h2 = H2;
  readonly h3 = H3;
  readonly lead = LEAD;
  readonly body = BODY;
  readonly pad = SECTION_PAD;
  readonly btnPrimary = BTN_PRIMARY;
  readonly btnSecondary = BTN_SECONDARY;
  readonly textLink = TEXT_LINK;

  readonly v3Plans: readonly Plan[] = this.plans.map(toV3Plan);
  // Lead with the first plan that can be bought today (currently Standard).
  readonly leadPlan: Plan = this.v3Plans.find((p) => !p.comingSoon && p.name !== 'Enterprise') ?? this.v3Plans[0];

  private readonly nav = inject(Router);

  /** v2 wires a scroll-reveal observer here; v3 renders content immediately. */
  override ngOnInit(): void {}

  /** Enterprise goes to the Contact page (v2 scrolled to an on-page form); other plans use v2 checkout. */
  override handlePlanAction(plan: Plan): void {
    if (plan.name === 'Enterprise') {
      this.nav.navigate(['/contact']);
      return;
    }
    super.handlePlanAction(plan);
  }
}
